import React, { createContext, useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";

const StoreContext = createContext();

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStore must be used within StoreProvider");
  }
  return context;
};

export const StoreProvider = ({ children }) => {
  const user = useSelector((state) => state.auth.user);
  const [selectedStoreId, setSelectedStoreId] = useState(() => {
    // Use authenticated user's storeId first, fallback to localStorage if no user
    if (user?.storeId) {
      return user.storeId;
    }
    return localStorage.getItem("selectedStoreId") || null;
  });

  useEffect(() => {
    // Update selectedStoreId when user changes (login/logout)
    if (user?.storeId) {
      setSelectedStoreId(user.storeId);
    } else {
      // Only use localStorage if no authenticated user
      const storedStoreId = localStorage.getItem("selectedStoreId");
      setSelectedStoreId(storedStoreId || null);
    }
  }, [user]);

  useEffect(() => {
    if (selectedStoreId) {
      localStorage.setItem("selectedStoreId", selectedStoreId);
    } else {
      localStorage.removeItem("selectedStoreId");
    }
  }, [selectedStoreId]);

  const value = {
    selectedStoreId,
    setSelectedStoreId,
  };

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};
